import 'leaflet'
import 'leaflet-draw'
import 'leaflet-draw/dist/leaflet.draw.css'
import 'leaflet-measure-path'
import L from 'leaflet'
import 'leaflet-simple-map-screenshoter'
import { COLORS } from '@/utils'

export default {
  data() {
    return {
      hasEditableZones: false,
    }
  },
  methods: {
    getDrawLocales() {
      return {
        draw: {
          toolbar: {
            actions: { title: 'Отменить', text: 'Отменить' },
            finish: { title: 'Закончить', text: 'Закончить' },
            undo: {
              title: 'Удалить последнюю точку',
              text: 'Удалить последнюю точку',
            },
            buttons: {
              polyline: 'Линия',
              polygon: 'Многоугольник',
              rectangle: 'Прямоугольник',
              circle: 'Круг',
              marker: 'Метка',
              circlemarker: 'Круглая метка',
            },
          },
          handlers: {
            circle: {
              tooltip: {
                start:
                  'Кликните и удерживая кнопку мыши начните перемещать мышку чтобы нарисовать круг.',
              },
              radius: 'Радиус',
            },
            circlemarker: {
              tooltip: { start: 'Click map to place circle marker.' },
            },
            marker: { tooltip: { start: 'Click map to place marker.' } },
            polygon: {
              tooltip: {
                start: 'Кликните по карте чтобы начать рисовать фигуру.',
                cont: 'Кликните по карте чтобы продолжить рисовать фигуру.',
                end: 'Кликните по первой точке фигуры чтобы закончить.',
              },
            },
            polyline: {
              error: '<strong>Ошибка:</strong> края не должны пересекаться!',
              tooltip: {
                start: 'Кликните чтобы нарисовать линию.',
                cont: 'Кликните чтобы продолжить рисовать.',
                end: 'Кликните по последней точке чтобы перестать рисовать.',
              },
            },
            rectangle: {
              tooltip: {
                start:
                  'Кликните и удерживая кнопку мыши начните перемещать мышку чтобы нарисовать круг.',
              },
            },
            simpleshape: {
              tooltip: { end: 'Отпустите кнопку мыши чтобы закончить.' },
            },
          },
        },
        edit: {
          toolbar: {
            actions: {
              save: { title: 'Сохранить изменения', text: 'Сохранить' },
              cancel: {
                title: 'Отмена, все изменения будут удалены',
                text: 'Отмена',
              },
              clearAll: { title: 'Удалить все', text: 'Удалить все' },
            },
            buttons: {
              edit: 'Отредактировать',
              editDisabled: 'Нет ничего для редактирования',
              remove: 'Удалить',
              removeDisabled: 'Нет ничего для удаления',
            },
          },
          handlers: {
            edit: {
              tooltip: {
                text: 'Перетаскивайте метки на ребрах для редактирования.',
                subtext:
                  'Нажмите отмена чтобы вернуться к предыдущему состоянию.',
              },
            },
            remove: {
              tooltip: {
                text: 'Кликните что по нарисованому объекту чтобы удалить его.',
              },
            },
          },
        },
      }
    },
    getShapeOptions() {
      return {
        stroke: true,
        color: COLORS.blue,
        weight: 4,
        opacity: 0.5,
        clickable: true,
        dashArray: null,
        dashOffset: null,
      }
    },
    // for extend in childs components
    getDrawControlOptions() {
      const shapeOptions = this.getShapeOptions()
      return {
        draw: {
          marker: false,
          circlemarker: false,
          polyline: this.hasEditableZones
            ? false
            : {
                shapeOptions,
              },
          polygon: {
            shapeOptions,
          },
          rectangle: {
            shapeOptions,
          },
          circle: this.hasEditableZones
            ? false
            : {
                shapeOptions,
              },
        },
        edit: {
          featureGroup: this.editableLayers,
        },
      }
    },
    initMeasure() {
      this.editableLayers = new L.FeatureGroup()
      this.map.addLayer(this.editableLayers)
      // see https://github.com/Leaflet/Leaflet.draw
      L.drawLocal = Object.assign({}, this.getDrawLocales())
      this.drawControl = new L.Control.Draw(this.getDrawControlOptions())
      this.map.addControl(this.drawControl)
      this.map.on(L.Draw.Event.CREATED, this.onDrawObjectCreated)
      this.addMeasureUpdateListeners()
      this.map.on(L.Draw.Event.EDITSTOP, this.onEditStop)

      this.simpleMapScreenshoter = L.simpleMapScreenshoter({
        hidden: true,
      }).addTo(this.map)
      let customControl = L.Control.extend({
        options: {
          position: 'topleft',
        },
        onAdd: () => {
          let container = L.DomUtil.create(
            'div',
            'leaflet-bar leaflet-control leaflet-control-custom'
          )
          container.style.backgroundColor = 'white'
          container.style.backgroundImage =
            "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAmUlEQVRIiWNgGK6gB4h3k4h7SLFgPxC/I8Hwd1A9JFlAigZS1dPGAgUgdoHiC1DsQiRGV6+AbrgDEP8G4v9UwiCz7JAtqINKEOtiQvg/1Ew4aIAKUgv8h5o5cBZQmtEIWkBpRiPKAkryAf0tQE+mF8iwADmjYSRTewbMjEaqBXgzGgjIU9EH8sRoGHqlKboGmlY4NK8yhw4AAIC0mkTM/cqIAAAAAElFTkSuQmCC')"
          container.style.backgroundSize = '20px 20px'
          container.style.backgroundRepeat = 'no-repeat'
          container.style.backgroundPosition = 'center'
          container.style.width = '30px'
          container.style.height = '30px'
          container.onclick = () => {
            this.simpleMapScreenshoter
              .takeScreen('image')
              .then((image) => {
                let ImagetoPrint = (source) => {
                  return (
                    '<html><head><scri' +
                    'pt>function step1(){\n' +
                    "setTimeout('step2()', 10);}\n" +
                    'function step2(){window.print();window.close()}\n' +
                    '</scri' +
                    "pt></head><body onload='step1()'>\n" +
                    "<img style='margin: auto auto; width: 100%' src='" +
                    source +
                    "'/></body></html>"
                  )
                }
                var Pagelink = ''
                var pwa = window.open(Pagelink, '_new')
                pwa.document.open()
                pwa.document.write(ImagetoPrint(image))
                pwa.document.close()
              })
              .catch((e) => {
                // @fix: TypeError: Failed to execute 'createObjectURL' on 'URL': No function was found that matched the signature provided.
                console.error(e)
                this.$e.warningBox(
                  'Превышен объем доступной памяти вашего компьютера: закройте неиспользуемые программы, увеличьте масштаб карты, обновите страницу (Ctrl+R) и повторите попытку снова'
                )
              })
          }
          return container
        },
      })
      this.map.addControl(new customControl())
    },
    // TODO: recreate poly
    onEditStop() {
      this.editableLayers.eachLayer((layer) => {
        this.saveEdit(layer)
        L.setOptions(layer, this.getShapeOptions())
      })
    },
    addMeasureUpdateListeners() {
      let evts = [
        'dragend',
        'touchmove',
        'MSPointerMove',
        'touchend',
        'MSPointerUp',
      ]
      evts.forEach((evtName) => {
        this.map.on(evtName, () => {
          if (this.editableLayers) {
            this.editableLayers.eachLayer((layer) => {
              layer.updateMeasurements()
            })
          }
        })
      })
    },
    onDrawObjectCreated(e) {
      let { layer } = e
      this.editableLayers.addLayer(layer)

      if (this.hasEditableZones) {
        this.addZone(layer)

        layer.on('click', () => {
          layer.setStyle({ color: COLORS.orange })
        })
      }
      layer.showMeasurements(this.getMeasurementOptions())
    },
    // see https://github.com/ProminentEdge/leaflet-measure-path
    getMeasurementOptions() {
      return {
        lang: {
          totalLength: 'Общая длина',
          totalArea: 'Общая площадь',
          segmentLength: 'Длина отрезка',
        },
        formatDistance: (d) => {
          let unit = 'м'
          if (d > 1000) {
            d = d / 1000
            unit = 'км'
          }
          if (d < 100) {
            return d.toFixed(1) + ' ' + unit
          } else {
            return Math.round(d) + ' ' + unit
          }
        },
        formatArea: (a) => {
          let unit = 'м²'
          let adtA = a / 100
          let adtUnit = 'соток'
          if (a > 1000000) {
            a = a / 1000000
            unit = 'км²'
            adtA = a * 100
            adtUnit = 'Га'
          }
          if (a < 100) {
            return (
              a.toFixed(1) +
              ' ' +
              unit +
              ' / ' +
              adtA.toFixed(1) +
              ' ' +
              adtUnit
            )
          } else {
            return (
              Math.round(a) +
              ' ' +
              unit +
              ' / ' +
              Math.round(adtA) +
              ' ' +
              adtUnit
            )
          }
        },
      }
    },
  },
  mounted() {
    this.map && this.initMeasure()
  },
}
